import './../../scss/theme/components/gallery.scss';

window.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelectorAll('.pswp-gallery .container');

  grid.forEach(function(elem,i){

    const msnry = new Masonry(elem, {
      itemSelector: '.gallery__item',
      stagger: 0,
      transitionDuration: 0
    });
  
    msnry.on('layoutComplete', function () {
      const lightbox = GLightbox({
        selector: '.pswp-gallery .gallery__item',
        touchNavigation: true,
        loop: false,
        autoplayVideos: false,
        openEffect: 'zoom',
        closeEffect: 'fade',
        cssEfects: {
          // This are some of the animations included, no need to overwrite
          fade: { in: 'fadeIn', out: 'fadeOut' },
          zoom: { in: 'zoomIn', out: 'zoomOut' }
        }
      });
  
      lightbox.on('open', () => {
        setTimeout(function(){
          const gslide = document.querySelectorAll('.gslide iframe');
          gslide.forEach((slide) => {
            slide.setAttribute('scrolling', 'yes')
          })
        },1000)
      });
    });
  
    msnry.layout();
  });
  
});
